module.exports = __webpack_public_path__ + "static/media/GWC24 DEA Generic branding image.441ab9a4.jpg";